export const environment = {
  production: false,
  url: 'https://api.collaborators.people.test.private.unico.run/api/v1',
  url_onboarding: 'https://admin.people.test.private.unico.run/svc2',
  cdn_url: 'https://admin.people.test.private.unico.run/cdn2',
  identity_url: 'https://identityqa.acesso.io',
  base_url: 'https://admin.people.test.private.unico.run/',
  sign_url: 'https://sign-core-test.acesso.io',
  sign_id: 'DB8EF2DD966F2CE9F3237F1A1746143B346393D373C7268FFC32759DE06597EA',
  segment_key: 'aJSx6ITwDTBcFEq6je022Y0UrC52Khm1',
  redirect_uri: 'https://collaborators.people.test.private.unico.run/preauthorize',
  base_ongoing_url: 'https://collaborators.people.test.private.unico.run',
  base_sign_url: 'https://sign-test.acesso.io/bff/v1',
  sentry_key: 'N/A',
  launchDarklyClientId: '63b870113b5a4212abb0f0fa',
  mixpanel_token: 'f4069d9b550ea08e34089810c2abd5be',
};
